<div class="height-full" layout="column" layout-wrap="false">

	<pulse-in-video-carousel [hidden]="VideoPulse.isPulseFilterApplied$ | async" [ngClass]="styles.inThisVideo" [currentTimeSec]="currentTimeSec">
	</pulse-in-video-carousel>

	<pulse-timeline flex="fill" [ngClass]="styles.timeline" [currentTimeSec]="currentTimeSec" [timelineEntries]="VideoPulse.timelineEntries$ | async" [video]="video" [vgApi]="vgApi">
	</pulse-timeline>
</div>